import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux'
import { createStore } from 'redux'
import store from './store.js'

import AppComp from './components/AppComp.js';

if(document.getElementById('main')){
  var wW = document.documentElement.clientWidth / 2;
render(
  <Provider store={store}>
    <AppComp />
  </Provider>
  , document.getElementById('main'));
}



// WEBPACK FOOTER //
// ./src/js/main.js